import { useState, useEffect } from "react";
import { Main, Content } from "../../../components/Layout";
import { Col, Row } from "react-bootstrap";
import Slct from "../../../components/Slct";
import DatePicker from "../../../components/DatePicker";
import TableResponsive from "../../../components/TableResponsive";
import StarRate from "../../../components/StarRate";
import IcSetaDown from "../../../components/Svg/IcSetaDown";
import { ChartsBar } from "../../../components/Charts";
import styleButton from "../../../components/Button/Button.module.css";
import RadioTab from "../../../components/RadioTab";
import api from "../../../services/api";
import { formatDate } from "../../../util/functions";
import IcX from "../../../components/Svg/IcX";
import Loading from "../../../components/Loading";
import { PrintPage } from "../../../components/PrintPage";
import useWrapper from "../../../hooks/useWrapper";
import useFormat from "../../../hooks/utils/useFormat";

export default function ReportsAttendance() {
  const { setbreadcrumb, me, config } = useWrapper();
  const { stringToDate } = useFormat();

  const filterInit = {
    "Tipo do Relatório": "Atendimentos",
  };

  const [filter, setfilter] = useState(filterInit);

  const [attendancesRaw, setattendancesRaw] = useState();
  const [attendances, setattendances] = useState();

  const [feedbacksRaw, setfeedbacksRaw] = useState();
  const [feedbacks, setfeedbacks] = useState();

  useEffect(() => {
    (async function () {
      if (filter["Tipo do Relatório"] === "Atendimentos" && !attendancesRaw) {
        const _attendances = await api.get(`/attendance/general/report`, config);
        setattendancesRaw(_attendances.data);
      }
      if (filter["Tipo do Relatório"] === "Avaliações" && !feedbacksRaw) {
        const _feedbacks = await api.get(`/attendance/feedback/report`, config);
        setfeedbacksRaw(_feedbacks.data);
      }
    })();
  }, [filter["Tipo do Relatório"]]);

  useEffect(() => {
    attendancesRaw && setattendances(attendancesRaw);
  }, [attendancesRaw]);
  useEffect(() => {
    feedbacksRaw && setfeedbacks(feedbacksRaw);
  }, [feedbacksRaw]);

  const [users, setusers] = useState();
  const [groups, setgroups] = useState();
  const [resources, setresources] = useState();

  useEffect(() => {
    let _users = [];
    let _groups = [];
    let _resources = [];

    if (attendancesRaw) {
      attendancesRaw.forEach(__attendance => {
        _users.push({
          value: __attendance.user?.id,
          label: __attendance.user?.username,
        });
        _groups.push({
          value: __attendance.commercial?.id,
          label: `${__attendance.commercial?.course?.title} ${__attendance.commercial?.year}.${__attendance.commercial?.period}`,
        });
        _resources.push({
          value: __attendance.resource?.id,
          label: __attendance.resource?.name,
        });
      });
    }
    if (feedbacksRaw) {
      feedbacksRaw.forEach(__feedback => {
        _users.push({
          value: __feedback.user?.id,
          label: __feedback.user?.username,
        });
        _groups.push({
          value: __feedback.commercial?.id,
          label: `${__feedback.commercial?.course?.title} ${__feedback.commercial?.year}.${__feedback.commercial?.period}`,
        });
        _resources.push({
          value: __feedback.resource?.id,
          label: __feedback.resource?.name,
        });
      });
    }
    _users = _users.filter((v, i, a) => a.findIndex(v2 => v2.value === v.value) === i).filter(_user => !!_user.label);
    _groups = _groups
      .filter((v, i, a) => a.findIndex(v2 => v2.value === v.value) === i)
      .filter(_group => !!_group.value);
    _resources = _resources
      .filter((v, i, a) => a.findIndex(v2 => v2.value === v.value) === i)
      .filter(_resource => !!_resource.value);

    _users.push({ value: "", label: " -- Todos --" });
    _groups.push({ value: "", label: " -- Todas --" });
    _resources.push({ value: "", label: " -- Todos --" });

    setusers(_users);
    setgroups(_groups);
    setresources(_resources);
  }, [attendancesRaw, feedbacksRaw]);

  useEffect(() => {
    if (filter["Tipo do Relatório"] === "Atendimentos" && attendancesRaw) {
      let _attendances = [...attendancesRaw];

      if (filter["Atendente"]?.value) {
        _attendances = [..._attendances].filter(__a => __a.user?.id === filter["Atendente"]?.value);
      }
      if (filter["Turma"]?.value) {
        _attendances = [..._attendances].filter(__a => __a.commercial?.id === filter["Turma"]?.value);
      }
      if (filter["Recurso"]?.value) {
        _attendances = [..._attendances].filter(__a => __a.resource?.id === filter["Recurso"]?.value);
      }
      if (filter["Data Inicial"]) {
        _attendances = [..._attendances].filter(
          __a => stringToDate(__a.created_at) >= stringToDate(filter["Data Inicial"]),
        );
      }
      if (filter["Data Final"]) {
        _attendances = [..._attendances].filter(
          __a => stringToDate(__a.created_at) <= stringToDate(filter["Data Final"]),
        );
      }
      if (filter["Status"] === "Em Andamento") {
        _attendances = [..._attendances].filter(__a => __a.status !== "resolvido" && __a.status !== "cancelado");
      } else if (filter["Status"] === "Finalizado") {
        _attendances = [..._attendances].filter(__a => __a.status === "resolvido");
      } else if (filter["Status"] === "Cancelado") {
        _attendances = [..._attendances].filter(__a => __a.status === "cancelado");
      }
      setattendances(_attendances);
    } else if (filter["Tipo do Relatório"] === "Avaliações" && feedbacksRaw) {
      let __feedbacks = [...feedbacksRaw];

      if (filter["Atendente"]?.value) {
        __feedbacks = [...__feedbacks].filter(__a => __a.user?.id === filter["Atendente"]?.value);
      }
      if (filter["Turma"]?.value) {
        __feedbacks = [...__feedbacks].filter(__a => __a.commercial?.id === filter["Turma"]?.value);
      }
      if (filter["Recurso"]?.value) {
        __feedbacks = [...__feedbacks].filter(__a => __a.resource?.id === filter["Recurso"]?.value);
      }
      if (filter["Data Inicial"]) {
        __feedbacks = [...__feedbacks].filter(
          __a => stringToDate(__a.created_at) >= stringToDate(filter["Data Inicial"]),
        );
      }
      if (filter["Data Final"]) {
        __feedbacks = [...__feedbacks].filter(
          __a => stringToDate(__a.created_at) <= stringToDate(filter["Data Final"]),
        );
      }
      if (filter["Avaliação"]) {
        __feedbacks = [...__feedbacks].filter(__a => (__a.avaliation || 1) === filter["Avaliação"]);
      }

      setfeedbacks(__feedbacks);
    }
  }, [filter]);

  const [reports, setreports] = useState();
  useEffect(() => {
    if (attendances) {
      if (filter["Tipo do Relatório"] === "Atendimentos") {
        setreports({
          data: [
            {
              label: "Em Andamento",
              value: attendances?.filter(
                __attendance => __attendance.status !== "resolvido" && __attendance.status !== "cancelado",
              )?.length,
            },
            {
              label: "Finalizados",
              value: attendances?.filter(__attendance => __attendance.status === "resolvido")?.length,
            },
            {
              label: "Cancelados",
              value: attendances?.filter(__attendance => __attendance.status === "cancelado")?.length,
            },
          ],
          title: "Atendimentos",
          type: "atendimentos",
          table: attendances?.map(__attendance => ({
            Protocolo: __attendance.id,
            Atendente: __attendance.user?.username || "-",
            Formando: __attendance.trainee?.name || "-",
            Turma: __attendance.commercial
              ? `(${__attendance.commercial?.course?.title} ${__attendance.commercial?.year}.${__attendance.commercial?.period})`
              : "-",
            Recurso: __attendance.resource?.name || "-",
            Data: formatDate(__attendance.created_at, 2),
            Duração: (() => {
              const _diffTime = Math.abs(new Date() - stringToDate(__attendance.created_at));
              const _diffDays = Math.ceil(_diffTime / (1000 * 60 * 60 * 24));
              return `${_diffDays} dias`;
            })(),
          })),
        });
      } else if (filter["Tipo do Relatório"] === "Avaliações") {
        setreports({
          data: [
            {
              label: "1 Estrela",
              value: feedbacks?.filter(__feedback => __feedback.avaliation === 0 || __feedback.avaliation === 1).length,
            },
            { label: "2 Estrelas", value: feedbacks?.filter(__feedback => __feedback.avaliation === 2).length },
            { label: "3 Estrelas", value: feedbacks?.filter(__feedback => __feedback.avaliation === 3).length },
            { label: "4 Estrelas", value: feedbacks?.filter(__feedback => __feedback.avaliation === 4).length },
            { label: "5 Estrelas", value: feedbacks?.filter(__feedback => __feedback.avaliation === 5).length },
          ],
          title: "Avaliações",
          type: "avaliações",
          table: feedbacks?.map(__feedback => ({
            Protocolo: __feedback.id,
            Atendente: __feedback.user?.username || "-",
            Formando: __feedback.trainee?.name,
            "Turma: ": __feedback.commercial
              ? `(${__feedback.commercial?.course?.title} ${__feedback.commercial?.year}.${__feedback.commercial?.period})`
              : "-",
            Recurso: __feedback.resource?.name || "-",
            Data: formatDate(__feedback.created_at, 2),
            Duração: (() => {
              const _diffTime = Math.abs(new Date() - stringToDate(__feedback.created_at));
              const _diffDays = Math.ceil(_diffTime / (1000 * 60 * 60 * 24));
              return `${_diffDays} dias`;
            })(),
            Avaliação: __feedback.avaliation || 1,
            "Avaliação Texto": `"${__feedback.attended_text || ""}"`,
          })),
        });
      }
    }
  }, [attendances, feedbacks, filter["Tipo do Relatório"]]);

  useEffect(() => {
    setbreadcrumb([{ label: "Relatórios" }]);
  }, []);

  return (
    <PrintPage has_logo={true} signed_by={me.username}>
      <Main>
        <Content>
          <Row>
            <Col>
              <div className="d-flex justify-content-between">
                <h2 className="page-title">Relatórios do Atendimento</h2>
                <span>
                  <PrintPage.PrintButton label="Gerar PDF" />
                  <PrintPage.CSVButton
                    label="Gerar CSV"
                    title={reports?.title}
                    overview={reports?.data}
                    // table={[]}
                    table={reports?.table?.map(_row => ({
                      ...(_row["Protocolo"] !== undefined && { Protocolo: _row["Protocolo"] }),
                      ...(_row["Atendente"] !== undefined && { Atendente: _row["Atendente"] }),
                      ...(_row["Turma"] !== undefined && { Turma: _row["Turma"] }),
                      ...(_row["Recurso"] !== undefined && { Recurso: _row["Recurso"] }),
                      ...(_row["Data"] !== undefined && { Data: _row["Data"] }),
                      ...(_row["Duração"] !== undefined && { Duração: _row["Duração"] }),
                      ...(_row["Avaliação"] !== undefined && { Avaliação: _row["Avaliação"] }),
                      ...(_row["Avaliação Texto"] !== undefined && { "Avaliação Texto": _row["Avaliação Texto"] }),
                    }))}
                    signed_by={me.username}
                    filter={{
                      "Tipo do Relatório": filter["Tipo do Relatório"],
                      Atendente: filter["Atendente"]?.label,
                      Turma: filter["Turma"]?.label,
                      Recurso: filter["Recurso"]?.label,
                      "Data Inicial": formatDate(filter["Data Inicial"], 2),
                      "Data Final": formatDate(filter["Data Final"], 2),
                      ...(filter["Status"] !== undefined && { Status: filter["Status"] }),
                      ...(filter["Avaliação"] !== undefined && { Avaliação: filter["Avaliação"] }),
                    }}
                  />
                </span>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col sm={3}>
              <span className="lince-input_label">Tipo do Relatório</span>
              <RadioTab
                options={[
                  { value: "Atendimentos", label: "Atendimentos" },
                  { value: "Avaliações", label: "Avaliações" },
                ]}
                value={filter["Tipo do Relatório"]}
                setvalue={__value => {
                  setfilter({
                    ...filter,
                    "Tipo do Relatório": __value,
                  });
                }}
              />
            </Col>
            {(attendancesRaw || feedbacksRaw) && (
              <>
                <Col sm={3}>
                  <span className="lince-input_label">Atendente</span>
                  <Slct
                    className="w-100"
                    placeholder="..."
                    value={filter["Atendente"]?.value}
                    options={users || []}
                    onChange={e => {
                      setfilter({
                        ...filter,
                        Atendente: e,
                      });
                    }}
                  />
                </Col>
                <Col sm={3}>
                  <span className="lince-input_label">Turma</span>
                  <Slct
                    className="w-100"
                    placeholder="..."
                    value={filter["Turma"]?.value}
                    options={groups || []}
                    onChange={e => {
                      setfilter({
                        ...filter,
                        Turma: e,
                      });
                    }}
                  />
                </Col>
                <Col sm={3}>
                  <span className="lince-input_label">Recurso</span>
                  <Slct
                    className="w-100"
                    placeholder="..."
                    value={filter["Recurso"]?.value}
                    options={resources || []}
                    onChange={e => {
                      setfilter({
                        ...filter,
                        Recurso: e,
                      });
                    }}
                  />
                </Col>
              </>
            )}
          </Row>
          {(attendancesRaw || feedbacksRaw) && (
            <>
              <Row className="mt-3">
                <Col sm={3}>
                  <span className="lince-input_label">Data Inicial</span>
                  <DatePicker
                    selected={filter["Data Inicial"]}
                    changeDate={e => {
                      setfilter({
                        ...filter,
                        "Data Inicial": e,
                        ...(!filter["Data Final"] && { "Data Final": e }),
                      });
                    }}
                  />
                </Col>
                <Col sm={3}>
                  <span className="lince-input_label">Data Final</span>
                  <DatePicker
                    selected={filter["Data Final"]}
                    changeDate={e => {
                      setfilter({
                        ...filter,
                        "Data Final": e,
                      });
                    }}
                  />
                </Col>
                {filter["Tipo do Relatório"] === "Atendimentos" && (
                  <>
                    <Col sm={3}>
                      <span className="lince-input_label">Status</span>
                      <Slct
                        className="w-100"
                        placeholder="..."
                        value={filter["Status"]}
                        sortBy={false}
                        options={[
                          { value: "", label: " -- Todos --" },
                          { value: "Em Andamento", label: "Em Andamento" },
                          { value: "Finalizado", label: "Finalizado" },
                          { value: "Cancelado", label: "Cancelado" },
                        ]}
                        onChange={e => {
                          setfilter({
                            ...filter,
                            Status: e.value,
                          });
                        }}
                      />
                    </Col>
                    {/* <Col sm={3}>
                    <span className='lince-input_label'>Duração Máxima</span>
                    <Slct
                      sortBy={false}
                      className="w-100"
                      placeholder="..."
                      value={filter["Status"]}
                      options={[{ value: "", label: "-- Todos --" }, { value: "Um Dia", label: "Um Dia" }, { value: "Uma Semana", label: "Uma Semana" }, { value: "Um Mês", label: "Um Mês" }, { value: "Mais de um Mês", label: "Mais de um Mês" }]}
                      onChange={e => {
                        setfilter({
                          ...filter,
                          duration: e.value
                        })
                      }}
                    />
                  </Col> */}
                  </>
                )}
                {filter["Tipo do Relatório"] === "Avaliações" && (
                  <>
                    <Col sm={3}>
                      <span className="lince-input_label">Avaliação</span>
                      <Slct
                        className="w-100"
                        placeholder="..."
                        value={filter["Avaliação"]}
                        options={[
                          { value: "", label: "-- Todas --" },
                          { value: 1, label: "1 Estrela" },
                          { value: 2, label: "2 Estrelas" },
                          { value: 3, label: "3 Estrelas" },
                          { value: 4, label: "4 Estrelas" },
                          { value: 5, label: "5 Estrelas" },
                        ]}
                        onChange={e => {
                          setfilter({
                            ...filter,
                            Avaliação: e.value,
                          });
                        }}
                      />
                    </Col>
                  </>
                )}
              </Row>
            </>
          )}
          <Row>
            <Col>
              <button
                onClick={() => {
                  setfilter(filterInit);
                }}
                className={`clear-search ${
                  JSON.stringify(filter) === JSON.stringify(filterInit) ? "disabled" : "mt-3"
                }`}
              >
                <span>
                  <span>
                    <IcX />
                  </span>
                  <span>Limpar busca</span>
                </span>
              </button>
            </Col>
          </Row>
          <Row>
            <Col>
              {filter["Tipo do Relatório"] === "Atendimentos" && attendancesRaw && (
                <ChartsBar
                  reports={[
                    {
                      label: "Em Andamento",
                      value: attendances?.filter(
                        __attendance => __attendance.status !== "resolvido" && __attendance.status !== "cancelado",
                      )?.length,
                    },
                    {
                      label: "Finalizados",
                      value: attendances?.filter(__attendance => __attendance.status === "resolvido")?.length,
                    },
                    {
                      label: "Cancelados",
                      value: attendances?.filter(__attendance => __attendance.status === "cancelado")?.length,
                    },
                  ]}
                  title={null}
                  type={"Atendimentos"}
                />
              )}
              {filter["Tipo do Relatório"] === "Avaliações" && feedbacksRaw && (
                <ChartsBar
                  reports={[
                    {
                      label: "1 Estrela",
                      value: feedbacks?.filter(__feedback => __feedback.avaliation === 0 || __feedback.avaliation === 1)
                        .length,
                    },
                    { label: "2 Estrelas", value: feedbacks?.filter(__feedback => __feedback.avaliation === 2).length },
                    { label: "3 Estrelas", value: feedbacks?.filter(__feedback => __feedback.avaliation === 3).length },
                    { label: "4 Estrelas", value: feedbacks?.filter(__feedback => __feedback.avaliation === 4).length },
                    { label: "5 Estrelas", value: feedbacks?.filter(__feedback => __feedback.avaliation === 5).length },
                  ]}
                  title={null}
                  type={"Atendimentos"}
                />
              )}
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              {filter["Tipo do Relatório"] === "Atendimentos" && (
                <>
                  {attendancesRaw ? (
                    <TableResponsive
                      table={{
                        head: [
                          { data: "Protocolo" },
                          { data: "Atendente" },
                          { data: "Formando, Turma e Recurso" },
                          { data: "Data e Duração" },
                        ],
                        body:
                          attendances?.map(__atendance => ({
                            link: `/attendance/edit/${__atendance.id}`,
                            data: [
                              { element: <span>{__atendance.id}</span> },
                              { element: __atendance.user?.username || "-" },
                              {
                                element: (
                                  <>
                                    <p>
                                      <b>{__atendance.trainee?.name}</b>{" "}
                                      {__atendance.commercial
                                        ? `(${__atendance.commercial?.course?.title} ${__atendance.commercial?.year}.${__atendance.commercial?.period})`
                                        : ""}
                                    </p>
                                    <p className="op-5">{__atendance.resource?.name || "-"}</p>
                                  </>
                                ),
                              },
                              {
                                element: (
                                  <>
                                    <p>{formatDate(__atendance.created_at, 2)}</p>
                                    <p className="op-5">
                                      {(() => {
                                        const _diffTime = Math.abs(new Date() - stringToDate(__atendance.created_at));
                                        const _diffDays = Math.ceil(_diffTime / (1000 * 60 * 60 * 24));
                                        return `${_diffDays} dias`;
                                      })()}
                                    </p>
                                  </>
                                ),
                              },
                            ],
                            border:
                              __atendance.status === "resolvido"
                                ? "var(--color-cycle-2)"
                                : __atendance.status === "cancelado"
                                ? "var(--color-cycle-3)"
                                : "var(--color-cycle-1)",
                          })) || [],
                      }}
                    />
                  ) : (
                    <Loading />
                  )}
                </>
              )}
              {filter["Tipo do Relatório"] === "Avaliações" && (
                <>
                  <p>
                    <b>Média:</b>{" "}
                    {(
                      feedbacks?.reduce((__acc, __feedback) => __acc + (__feedback.avaliation || 1), 0) /
                        feedbacks?.length || 0
                    ).toFixed(1)}
                  </p>
                  {feedbacksRaw ? (
                    <TableResponsive
                      table={{
                        head: [
                          { data: "Protocolo" },
                          { data: "Atendente" },
                          { data: "Formando, Turma e Recurso" },
                          { data: "Data e Duração" },
                          { data: "Avaliação" },
                          { data: "" },
                        ],
                        body:
                          feedbacks?.map(__feedback => ({
                            link: `/attendance/edit/${__feedback.id}`,
                            data: [
                              { element: <span>{__feedback.id}</span> },
                              { element: __feedback.user?.username || "-" },
                              {
                                element: (
                                  <>
                                    <p>
                                      <b>{__feedback.trainee?.name}</b>{" "}
                                      {__feedback.commercial
                                        ? `(${__feedback.commercial?.course?.title} ${__feedback.commercial?.year}.${__feedback.commercial?.period})`
                                        : ""}
                                    </p>
                                    <p className="op-5">{__feedback.resource?.name || "-"}</p>
                                  </>
                                ),
                              },
                              {
                                element: (
                                  <>
                                    <p>{formatDate(__feedback.created_at, 2)}</p>
                                    <p className="op-5">
                                      {(() => {
                                        const _diffTime = Math.abs(new Date() - stringToDate(__feedback.created_at));
                                        const _diffDays = Math.ceil(_diffTime / (1000 * 60 * 60 * 24));
                                        return `${_diffDays} dias`;
                                      })()}
                                    </p>
                                  </>
                                ),
                              },
                              {
                                element: (
                                  <div style={{ height: "18px" }}>
                                    <StarRate rate={__feedback.avaliation || 1} readonly="true" />
                                  </div>
                                ),
                              },
                              {
                                element: !!__feedback.attended_text ? (
                                  <span className="simple-ico" style={{ cursor: "pointer" }}>
                                    <IcSetaDown />
                                  </span>
                                ) : (
                                  <></>
                                ),
                                id: "rate",
                                spoiler: (
                                  <>
                                    {/* {!!__feedback.attended_text && ( */}
                                    <>
                                      <p>
                                        <b>Avaliação</b>
                                      </p>
                                      <p>{__feedback.attended_text}</p>
                                    </>
                                    {/* )} */}
                                  </>
                                ),
                              },
                            ],
                            border: `var(--color-cycle-${__feedback.avaliation || 1})`,
                          })) || [],
                      }}
                    />
                  ) : (
                    <Loading />
                  )}
                </>
              )}
            </Col>
          </Row>
        </Content>
      </Main>
    </PrintPage>
  );
}
